import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import PropTypes from "prop-types";

/**
 * ThemeProvider component wrapper for Material-UI ThemeProvider.
 * Wraps Material-UI ThemeProvider with theme integration.
 * 
 * @component
 * @example
 * <ThemeProvider theme={theme}>
 *   {children}
 * </ThemeProvider>
 */
const ThemeProvider = ({ children, ...props }) => {
  return <MuiThemeProvider {...props}>{children}</MuiThemeProvider>;
};

ThemeProvider.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The theme object
   */
  theme: PropTypes.object.isRequired,
};

export default ThemeProvider;
